<a
  id="skippy"
  class="sr-only sr-only-focusable"
  [href]="getSkipLink() + '#main-content'"
>
  <div class="container">
    <span class="skiplink-text">Vai al contenuto principale</span>
  </div>
</a>

<a
  id="skippy2"
  class="sr-only sr-only-focusable"
  [href]="getSkipLink() + '#footer'"
>
  <div class="container">
    <span class="skiplink-text">Vai al footer</span>
  </div>
</a>

<div class="it-header-slim-wrapper">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div
          class="it-header-slim-wrapper-content justify-content-sm-between justify-content-end"
        >
          <a class="d-none d-sm-block navbar-brand" href="https://www.aifa.gov.it/" i18n="@@search-page.top-header-title"
            >AIFA - Agenzia Italiana del Farmaco</a
          >
          <div class="it-header-slim-right-zone">
            <ul class="navbar-nav">
              <li class="nav-item">
               
                <a class="navbar-brand me-4" href="https://trovanorme.aifa.gov.it/#/" >
                  <span i18n="@@search-page.top-header.trova-nome-farmaco-text"
                  style="padding: 3px;">Trova Norme Farmaco</span
                  >
              
               
                  <img
                    alt="AIFA Medicinali"
                    i18n-alt="Alt per logo AIFA|Sezione header"
                    src="assets/icons/Vector.svg"
                    class="image"
                  />
                </a>
              
              </li>
            </ul>
            <div class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle mt-1"
                href="#"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span class="visually-hidden"
                  >Selezione lingua: lingua selezionata</span
                >
                <span>{{lang}}</span>
                <svg class="icon d-block">
                  <use href="assets/icons/sprites.svg#it-expand"></use>
                </svg>
              </a>
              <div class="dropdown-menu">
                <div class="row">
                  <div class="col-12">
                    <div class="link-list-wrapper">
                      <ul class="link-list">
                        <li>
                          <a class="dropdown-item list-item" href={{url_it}}
                            ><span
                              >ITA<span class="visually-hidden"
                                >selezionata</span
                              ></span
                            ></a
                          >
                        </li>
                        <li>
                          <a class="dropdown-item list-item" href={{url_en}}
                            ><span>ENG</span></a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="it-header-center-wrapper header">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="it-header-center-content-wrapper">
          <div class="it-brand-wrapper">
            <div class="logo-container">
              <a [routerLink]="'/'">
                <img
                  alt="AIFA Medicinali"
                  i18n-alt="Alt per logo AIFA|Sezione header"
                  src="assets/icons/logo@3x.svg"
                  class="image me-4"
                />
                <div class="it-brand-text">
                  <div class="it-brand-title" i18n="@@search-page.header-title">
                    AIFA Medicinali
                  </div>
                  <div
                    class="it-brand-tagline d-block"
                    i18n="@@search-page.header-sub-title"
                  >
                    Agenzia Italiana del Farmaco
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
